import { render, staticRenderFns } from "./ErrorConfigEdit.vue?vue&type=template&id=c9277a2c&scoped=true"
import script from "./ErrorConfigEdit.vue?vue&type=script&lang=js"
export * from "./ErrorConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./ErrorConfigEdit.vue?vue&type=style&index=0&id=c9277a2c&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9277a2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9277a2c')) {
      api.createRecord('c9277a2c', component.options)
    } else {
      api.reload('c9277a2c', component.options)
    }
    module.hot.accept("./ErrorConfigEdit.vue?vue&type=template&id=c9277a2c&scoped=true", function () {
      api.rerender('c9277a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/errorConfig/ErrorConfigEdit.vue"
export default component.exports